import type { LoginRequest, LoginResponse } from './Type';
import { request } from '@/utils/Request';

export const login = (data: LoginRequest) => {
  return request.post<LoginResponse>("/api/user/login", data);
}

